import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/admin/AdminAuthContext";
import AdminLayout from "@/admin/AdminLayout";

export default function ProtectedAdminRoute({ children }) {
  const { user, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-offwhite flex items-center justify-center" data-testid="admin-loading">
        <div className="text-mutedink text-sm uppercase tracking-widest">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (user.must_change_password && location.pathname !== "/admin/change-password") {
    return <Navigate to="/admin/change-password" replace />;
  }

  return <AdminLayout>{children}</AdminLayout>;
}
